/**
 * FILE: NewsCard.js
 * PURPOSE: The "Insight Report" card.
 * WHAT IT DOES: It shows a summary of a completed poll and what the final verdict or conclusion was.
 * LAYMAN SUMMARY: These cards look like mini news articles that tell you the result of a big community debate.
 */
import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function NewsCard({ headline, summary, category, img }) {
  return (
    <div className="w-full bg-white dark:bg-gray-800 rounded-[32px] overflow-hidden border border-gray-100 dark:border-gray-700 shadow-xl shadow-purple-900/5 group/news transition-all hover:border-primary-600/20">
      <div className="relative aspect-[16/9] overflow-hidden">
        <img src={img} className="w-full h-full object-cover transition-transform duration-1000 group-hover/news:scale-105" alt="news context" />
        <div className="absolute top-6 left-6">
          <div className="px-3 py-1 bg-black text-white rounded-full text-2xs font-black uppercase tracking-[0.2em] shadow-2xl">
            FINAL VERDICT
          </div>
        </div>
      </div>

      <div className="p-8 space-y-4">
        <div className="flex items-center space-x-2">
          <span className="text-2xs font-black text-primary-600 uppercase tracking-[0.3em]">{category}</span>
          <span className="w-1 h-1 bg-gray-200 dark:bg-gray-700 rounded-full"></span>
          <span className="text-2xs font-bold text-gray-500 uppercase tracking-widest">Public Record Analysis</span>
        </div>

        <h2 className="text-2xl font-serif font-black text-[#1F2937] dark:text-white leading-tight group-hover/news:text-primary-600 transition-colors">
          {headline}
        </h2>

        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed font-medium">
          {summary}
        </p>

        <button className="w-full py-4 mt-4 border border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-700/50 rounded-xl font-black uppercase text-[11px] tracking-[0.2em] text-gray-600 dark:text-gray-300 hover:bg-primary-600 dark:hover:bg-primary-600 hover:text-white dark:hover:text-white hover:border-primary-600 dark:hover:border-primary-600 transition-all flex items-center justify-center space-x-2 group/btn">
          <span>Read Full Analysis</span>
          <ArrowRight size={14} className="transition-transform group-hover/btn:translate-x-1" />
        </button>
      </div>
    </div>
  );
}